
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getPipelineTranslationsDiff",
      resolverType: "query",
      routePath: "/getPipelineTranslationsDiff",
      httpMethod: "POST",
    });
  